import React from 'react';
import LinkedInWhite from '../../assets/imgs/socialMedia/linkedIn-white.svg';
import { useNavigate } from 'react-router-dom';
import Button from '../shared/Button';

const CareersJoin = () => {

  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };

  return (
    <div className="xl:px-52 md:px-20 px-10 py-20 3xl:max-w-[1500px] 3xl:inline-block">
      <div className="grid md:grid-cols-2 gap-4 items-center">
        <div className="text-left">
          <h2 className="font-bold text-blue-800 text-3xl mb-5">Why work with Us?</h2>
          <ul className="text-xl list-disc pl-5 space-y-2">
            <li>You are part of a great company.</li>
            <li>We work together to design your career plan.</li>
            <li>We want you to support our strategy.</li>
            <li>We are family.</li>
            <li>We work together to build our dream.</li>
          </ul>
        </div>
        <div className="text-left">
          <h2 className="font-bold text-blue-800 text-3xl mb-5">Join our Dream</h2>
          <p className="text-xl mb-5">
            All our positions at FactorK are remotely based. We work with amazing companies from the US to Latin America and our Sherpas are based in Costa Rica and El Salvador.
            Although we're a remote company, our full-time employees still receive a fantastic set of perks and benefits. Find out more below.
          </p>
        </div>
        <div className="flex ml-10 justify-start mt-5 mb-5">
          <Button
            className="bg-blue-800 text-white-100 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900"
            onClick={handleContactClick}
            aria-label="Let's talk!"
          >
            Learn about our services
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="text-center">
          <h2 className="text-xl mb-3">View our complete list of open positions in LinkedIn here:</h2>
          <a href="https://www.linkedin.com/company/jobs-factor-k-software/posts" target="_blank" rel="noreferrer" className="inline-block">
            <Button className="min-w-[48px] min-h-[48px] px-6 py-3 bg-blue-800 text-white-50 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900 flex justify-center items-center gap-1">
              <img alt="linkedIn" src={LinkedInWhite} className="w-4 mb-1" />
              LinkedIn Jobs
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default CareersJoin;
